// CheckboxGrid.jsx
import React from 'react';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';

function CheckboxGrid({ items, selectedValues, onCheckboxChange, category, category1 }) {
  return (
    <Grid sx={{ marginBottom: '20px' }}>
      <h4>{category}</h4>
      {category1 ?? <h5>{category1}</h5>}
      <Grid container spacing={2}>
        {items.map((med) => (
          <Grid item key={med.value} xs={6} sm={4}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={selectedValues.includes(med.value)}
                  onChange={(event) => onCheckboxChange(event, selectedValues)}
                  value={med.value}
                  style={{ color: selectedValues.includes(med.value) ? '#66b5a3' : 'inherit' }}
                />
              }
              label={med.label}
            />
          </Grid>
        ))}
      </Grid>
    </Grid>
  );
}

export default CheckboxGrid;
